import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { ReportService } from '../../../../services/aws/report/report.service';
import { IReport } from '../../../../models/IReport';
import { IErrorMessage } from 'src/app/widgets/error-message/error-message.interface';
import { API_USER_DEFINED_MESSAGE } from 'src/app/widgets/error-message/error-message.const';

@Component({
    selector: 'report-departure',
    templateUrl: './departure.component.html',
    standalone: false
})
export class ReportDepartureComponent implements OnInit {
    reports: IReport[];
    showLoading: any;
    isDesc: boolean = false;
    column: string = 'lastName';
    direction: number;
    isNameAsc: boolean = false;
    isMobileAsc: boolean = false;
    isStatusAsc: boolean = false;
    isAirLineAsc: boolean = false;
    isFlightNoAsc: boolean = false;
    isDepartDateAsc: boolean = false;
    isDepartTimeAsc: boolean = false;
    search: any;
    filterValue: any;

    breadcrumbOptions = {
        breadcrumb: [
            {
                label: 'Dashboard',
                itemclass: 'Breadcrumb-item',
                linkclass: 'Breadcrumb-link',
                link: '/admin/dashboard'
            },
            // {
            //     label: 'Reporting',
            //     itemclass: 'Breadcrumb-item',
            //     linkclass: 'Breadcrumb-link',
            // },
            {
                label: 'Flight Departure',
                itemclass: 'Breadcrumb-item',
                linkclass: 'Breadcrumb-link',
                link: '/admin/reports/departure'
            }
        ]
    };
    public errorMessage: IErrorMessage = {};

    constructor(private reportService: ReportService) { }

    ngOnInit() {
        this.errorMessage = {};

        this.reportService.getReport('flightDepartures').pipe(map(data => data))
            .subscribe((response: any) => {
                this.errorMessage.text = response?.length ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                this.reports = response;
            },
                () => {
                    this.reports = [];
                    this.errorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
                });

    }

    download() {
        this.reportService.getFlightReport('flightDepartures');
    }

    sort(property) {
        this.isDesc = !this.isDesc;
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        switch (property) {
            case 'lastName':
                this.isNameAsc = !this.isNameAsc;
                break;
            case 'mobileNumber':
                this.isMobileAsc = !this.isMobileAsc;
                break;
            case 'status':
                this.isStatusAsc = !this.isStatusAsc;
                break;
            case 'airline':
                this.isAirLineAsc = !this.isAirLineAsc;
                break;
            case 'flightNumber':
                this.isFlightNoAsc = !this.isFlightNoAsc;
                break;
            case 'departureDate':
                this.isDepartDateAsc = !this.isDepartDateAsc;
                break;
            case 'departureTime':
                this.isDepartTimeAsc = !this.isDepartTimeAsc;
        }
    }
}
